;(function () {
  'use strict'

  angular.module('contrast.users').constant('userBulkCreateErrors', [
    {
      errorType: 'REQUIRED_ATTRIBUTE_MISSING',
      displayName: 'Required Attribute Missing'
    },
    {
      errorType: 'INVALID_ROLE',
      displayName: 'Invalid Role'
    },
    {
      errorType: 'INVALID_ORGANIZATION',
      displayName: 'Invalid Organization'
    },
    {
      errorType: 'INVALID_FIRST_NAME',
      displayName: 'Invalid First Name'
    },
    {
      errorType: 'INVALID_LAST_NAME',
      displayName: 'Invalid Last Name'
    },
    {
      errorType: 'INVALID_EMAIL',
      displayName: 'Invalid Email'
    },
    {
      errorType: 'INVALID_USERNAME',
      displayName: 'Invalid Username'
    },
    {
      errorType: 'INVALID_HEADER',
      displayName: 'Invalid Header'
    },
    {
      errorType: 'INVALID_PARAMETER',
      displayName: 'Invalid Parameter'
    },
    {
      errorType: 'UNSUPPORTED_FILE_EXTENSION',
      displayName: 'Unsupported File Extension'
    },
    {
      errorType: 'INVALID_PASSWORD',
      displayName: 'Invalid Password'
    },
    {
      errorType: 'UNSUPPORTED_AUTHENTICATION_SETTINGS',
      displayName: 'Unsupported Authentication Settings'
    },
    {
      errorType: 'OTHER',
      displayName: 'Error'
    }
  ])
})()
